const DomUtils = {
    ready: (fn) => {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    },
    addEventListeners: (elements, eventTypes, handler) => {
        if (!elements || !Array.isArray(eventTypes) || !handler) {
            throw new Error('could not add eventListener');
        }
        Array.from(elements).forEach((element) => {
            eventTypes.forEach((type) => {
                element.addEventListener(type, handler);
            });
        });
    },
    /**
     * Creates a new DOM element with the specified tag name, attributes, and text content.
     * @param {string} tagName - The tag name of the element.
     * @param {Object} attributes - The attributes to set on the element.
     * @param {string} [className] - The class name to add to the element.
     * @param {string} [textContent] - The text content of the element.
     * @returns {Element} The created DOM element.
     */
    createDOMElement: (tagName, attributes = {}, className, textContent = '') => {
        const element = document.createElement(tagName);

        // Set attributes
        Object.entries(attributes).forEach(([attr, value]) => {
            element.setAttribute(attr, value);
        });

        // Set text content
        element.textContent = textContent;

        // Add class name
        if (className) {
            element.classList.add(className);
        }

        return element;
    },
};

export default DomUtils;
